import cfrUrl from '@/creditflowresearch/infrastructure/url';
import config from '@creditflowresearch/config';

const baseSchema = {
  '@context': 'https://schema.org/',
  publisher: {
    '@type': 'Organization',
    name: 'CreditFlow',
    url: cfrUrl.getUrl(),
    telephone: config.supportPhoneNumber,
    email: config.supportEmail,
  },
};

export default baseSchema;
